import { createContext } from 'react';

import type { LoginInput, RegisterInput } from './types';

export type AuthStatus = 'loading' | 'authenticated' | 'unauthenticated';

export interface AuthContextValue {
  status: AuthStatus;
  signIn: (input: LoginInput) => Promise<void>;
  /** Returns true when the account was created AND signed in (tokens issued);
   *  false when the backend demands email verification first. */
  signUp: (input: RegisterInput) => Promise<boolean>;
  signOut: () => Promise<void>;
  /** Re-fetch schools + current user (e.g. after creating a school). */
  refreshSession: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
